/* eslint-disable simple-import-sort/imports */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../button/button';
import { Dialog } from '../../../../dialog/dialog';
import { DropdownSuggestion } from '../../../../dropdown-suggestion/dropdown-suggesion';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { Stack } from '../../../../stack/stack';
import type { AssetCategoryFilter } from '../../../state/asset-filter-store';
import { ThemeManager } from '../../../../../themes/theme-manager';

type Props = {
  onClose: (type?: AssetCategoryFilter) => void;
};

type Suggestion = { id: AssetCategoryFilter; name: string };

const ObjectTypeDialog = (props: Props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = React.useState<Suggestion | undefined>(undefined);
  const isMobaTheme = ThemeManager.instance.isMobaTheme();

  const options: Suggestion[] = React.useMemo(
    () =>
      isMobaTheme
        ? [
            { id: 'Design', name: t('design.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'Poi', name: t('poi.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'CAD', name: t('cad.categoryName', { ns: 'skyviewAssetMenu' }) },
          ]
        : [
            { id: 'Design', name: t('design.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'Area', name: t('area.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'Line', name: t('line.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'Poi', name: t('poi.categoryName', { ns: 'skyviewAssetMenu' }) },
            { id: 'CAD', name: t('cad.categoryName', { ns: 'skyviewAssetMenu' }) },
            {
              id: 'Markmodeller',
              name: t('terrainModel.categoryName', { ns: 'skyviewAssetMenu' }),
            },
          ],
    [t, isMobaTheme],
  );

  const close = (value?: AssetCategoryFilter) => props.onClose(value);

  return (
    <Dialog closeIcon={true} closeOnDimmerClick={true} onClose={() => close()}>
      {{
        header: t('topArea.filter.type', { ns: 'skyviewAssetMenu' }),
        content: (
          <Stack spacing={1}>
            <LabelledContainer text={t('topArea.filter.type', { ns: 'skyviewAssetMenu' })}>
              <DropdownSuggestion
                alternativeSuggestionsLimit={6}
                clearOnSelection={true}
                id="objectType"
                placeholder={t('topArea.filter.noneSelectedPlaceholder', {
                  ns: 'skyviewAssetMenu',
                })}
                portalToBody={true}
                suggestions={options}
                value={selected?.id}
                onSuggestionSelected={(s) => setSelected(s)}
              />
            </LabelledContainer>
          </Stack>
        ),
        footer: {
          right: (
            <>
              <Button color="primary" variant="contained" onClick={() => close(selected?.id)}>
                {t('confirm', { ns: 'common' })}
              </Button>
              <Button variant="text" onClick={() => close()}>
                {t('cancel', { ns: 'common' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

export { ObjectTypeDialog };
